import { render, staticRenderFns } from "./DispatchNoteDropdown.vue?vue&type=template&id=33b3962c&"
import script from "./DispatchNoteDropdown.vue?vue&type=script&lang=js&"
export * from "./DispatchNoteDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports